import * as React from 'react';
import {Text} from 'react-native';
import {images} from '../../../../../assets/icons';
import {Button} from '../../../../../shared/components/button';
import Screen from '../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {useStyles} from '../../../../../shared/hooks/styles';
import {useBlockCardDialog} from '../../../../../shared/hooks/useBlockCardDialog';
import {Content} from '../../../../../shared/models/content';
import {useTheme} from '../../../../../shared/theme';

interface Props {
  cardIsBlocked: boolean;
  content: Content;
}

export default ({cardIsBlocked, content}: Props) => {
  const showBlockCardDialog = useBlockCardDialog();
  const theme = useTheme();
  const styles = useStyles(() => {
    return {
      scrollContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingBottom: 80,
        paddingHorizontal: 16,
      },
      message: {
        ...theme.fonts.body,
        color: theme.color.textColor,
        marginVertical: 40,
        textAlign: 'center',
      },
      button: {
        width: '100%',
        maxWidth: 328,
        alignSelf: 'center',
      },
      buttonText: {
        color: theme.color.primaryColor,
      },
      buttonIcon: {
        width: 24,
        height: 26,
      },
    };
  });

  return (
    <Screen>
      <CustomScrollView contentContainerStyle={styles.scrollContainer} contentInsetAdjustmentBehavior='automatic'>
        <Text style={styles.message} testID='safety-block--message'>
          {cardIsBlocked ? content.cardBlocking.unblockMessage : content.cardBlocking.blockMessage}
        </Text>
        <Button
          id='profile-safety-block-card'
          disabled={cardIsBlocked}
          type='secondary'
          text='Заблокировать карту'
          textStyle={styles.buttonText}
          icon={images.Lock}
          iconStyles={styles.buttonIcon}
          iconPosition='left'
          style={styles.button}
          iconProps={{color: theme.color.primaryColor}}
          onPress={showBlockCardDialog}
        />
      </CustomScrollView>
    </Screen>
  );
};
